import React, { useEffect, useState, useRef } from 'react';

// 이미지 import
import brand1 from '../../assets/images/brand/brand_brands_01.png';
import brand2 from '../../assets/images/brand/brand_brands_02.png';
import brand3 from '../../assets/images/brand/brand_brands_03.png';
import brand4 from '../../assets/images/brand/brand_brands_04.png';
import brand5 from '../../assets/images/brand/brand_brands_05.png';
import brand6 from '../../assets/images/brand/brand_brands_06.png';
import brand7 from '../../assets/images/brand/brand_brands_07.png';
import brand8 from '../../assets/images/brand/brand_brands_08.png';
import brand9 from '../../assets/images/brand/brand_brands_09.png';
import brand10 from '../../assets/images/brand/brand_brands_10.png';

const brandImages: { [key: number]: string } = {
  1: brand1,
  2: brand2,
  3: brand3,
  4: brand4,
  5: brand5,
  6: brand6,
  7: brand7,
  8: brand8,
  9: brand9,
  10: brand10,
};

const brands = Array(10).fill(0).map((_, idx) => ({
  id: idx + 1,
  image: brandImages[idx + 1]
}));

const BrandBrands = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      {
        threshold: 0.05,
        rootMargin: '-20px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-[#FDF4FF] flex flex-col items-center justify-center py-[80px] md:py-[140px]">
      <div className={`flex flex-col items-center transition-all duration-[2000ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
        <div className="w-full flex flex-col items-center">
          <h2 className="font-pretendard font-medium text-[30px] md:text-[40px] leading-[140%] font-normal text-black md:mb-24 mb-20 text-center w-full">함께하는 브랜드들</h2>
        </div>
        {/* 모바일: 2열, 데스크탑: 5열 (총 10개 → 2줄) */}
        <div className="grid grid-cols-2 md:grid-cols-5 justify-items-center gap-x-[60px] gap-y-[20px] md:gap-x-[120px] md:gap-y-[32px] w-full max-w-[320px] md:max-w-[800px]">
          {brands.map((brand) => (
            <div key={brand.id} className="w-[90px] md:w-[120px] h-[90px] md:h-[120px] flex items-center justify-center">
              <img 
                src={brand.image} 
                alt={`Brand ${brand.id}`}
                className="w-full h-full object-contain filter brightness-0"
                onError={(e) => {
                  console.error(`Failed to load image: ${brand.image}`);
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandBrands; 